import React from 'react';

import { connect } from 'react-redux';

import classes from './HotelPhotos.scss';

const hotelPhotos = (props) => {
    let images = [];
    
    for(let i = 0; i < props.hotelImages.length; i++) {
        let classImage = null;
        if(i === 0) {
            classImage = classes.GalleryItemOne;
        }
        if(i === 1) {
            classImage = classes.GalleryItemTwo;
        }
        if(i === 2) {
            classImage = classes.GalleryItemThree;
        }
        if(i === 3) {
            classImage = classes.GalleryItemFour;
        }
        if(i === 4) {
            classImage = classes.GalleryItemFive;
        }
        images.push(
            <figure key={i} className={[classes.GalleryItem, classImage].join(' ')}>
                <img src={props.hotelImages[i].url} className={classes.GalleryImage} alt='gallery'/>
            </figure>
        );
        if(i === 4) break;
    }
    console.log(images);

    return (
        <div className={classes.Gallery}>
            {images}
        </div>
    );
}

const mapStateToProps = state => {
    return {
        hotelImages: state.hotels.hotelImages
    }
}

export default connect(mapStateToProps)(hotelPhotos);


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelPhotos/HotelPhotos.js